const getFieldId = (modelId: string, fieldName: string) => {
  return `${modelId}.${fieldName}`
}

export default getFieldId
